import { observer } from 'mobx-react-lite'
import { ContainerHeader } from 'shared/ui'
import { useSurveysPageContext } from 'pages/surveys/context/surveysPageContext'
import { GuideButton, NewSurveyButton } from 'pages/surveys/ui/SurveysActions/SurveysActions'
import { SurveysTable } from './SurveysTable/SurveysTable'
import styles from './styles.module.scss'

export const SurveysList = observer(() => {
  const { pageLayoutStore } = useSurveysPageContext()
  const { titleIconProps, handleToggleCollapse } = pageLayoutStore

  return (
    <>
      <ContainerHeader
        title={'Surveys'}
        titleVariant={'heading-md'}
        titleIconProps={titleIconProps}
        titleIconAction={handleToggleCollapse}
        paddingLeft={20}
        paddingRight={20}
        actionsGap={8}
        actions={[
          {
            iconButtonComponent: <GuideButton className={styles.guideButton} />,
          },
          {
            iconButtonComponent: <NewSurveyButton />,
          },
        ]}
      />
      <div className={styles.wrap}>
        <SurveysTable />
      </div>
    </>
  )
})
